'use client';

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { Card } from 'src/components/PulseUI';

interface InsightCardProps {
  label: string;
  summary?: string;
  icon?: IconDefinition;
  iconClassName?: string;
  headerAction?: React.ReactNode;
  children?: React.ReactNode;
  onClick: () => void;
  'data-testid': string;
}

const InsightCard = ({
  label,
  summary,
  icon,
  iconClassName,
  headerAction,
  children,
  onClick,
  'data-testid': testId,
}: InsightCardProps) => (
  <Card
    className="px-5 py-4 bg-white border border-neutral-200 cursor-pointer transition-all rounded-xl"
    onClick={onClick}
    data-testid={testId}
    role="button"
    aria-label={label}
  >
    <div className="h-full flex items-center justify-between gap-3">
      <div className="flex items-center gap-2 min-w-0">
        {icon && (
          <Icon
            icon={icon}
            className={iconClassName ?? 'text-sm text-secondary flex-shrink-0'}
            aria-hidden="true"
          />
        )}
        <div className="flex flex-col gap-1 min-w-0">
          <span className="text-sm font-bold text-primary">{label}</span>
          {summary && (
            <span className="text-xs text-sky-600 font-medium line-clamp-2">
              {summary}
            </span>
          )}
        </div>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        {headerAction && (
          <div
            className="flex items-center"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            {headerAction}
          </div>
        )}
        <Icon
          icon={faChevronRight}
          className="text-xs text-secondary"
          aria-hidden="true"
        />
      </div>
    </div>
    {children && (
      <div className="mt-3 border-t border-neutral-100 pt-3">
        {children}
      </div>
    )}
  </Card>
);

export default InsightCard;
